// Tema do Ant Design, alinhado às telas emuladas do protótipo.
//
// O aplicativo é claro apenas. O tema escuro que existe no protótipo pertence
// à casca do documento que mostra os quadros, não ao aplicativo dentro deles:
// nas 28 telas não há nenhuma regra de prefers-color-scheme. Por isso aqui há
// um tema só, e nenhuma troca por preferência do sistema.
//
// As cores vêm de styles/tokens.css. Estão repetidas aqui porque o Ant precisa
// delas em JavaScript, e ele não lê variável CSS.

import type { ThemeConfig } from 'antd'

export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: '#00073C',
    colorInfo: '#1B4DE0',
    colorSuccess: '#008F5C',
    colorWarning: '#E2671B',
    colorError: '#A12A1B',

    colorTextBase: '#00073C',
    colorTextSecondary: '#5F5E5A',
    colorBgBase: '#FFFFFF',
    colorBgLayout: '#FAFAF7',
    colorBgContainer: '#FFFFFF',
    colorFillSecondary: '#F4F2EC',

    colorBorder: '#8F8D86', // contorno de campo
    colorBorderSecondary: '#E8E6DF', // divisória de cartão e tabela

    borderRadius: 8,
    fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
    fontSize: 15,
    controlHeight: 44,
  },
  components: {
    // No protótipo a ação principal é verde com texto navy, e a secundária é
    // branca contornada de navy. O navy segue sendo o primário do resto
    // (seleção, foco, caixa marcada), que lá também é desenhado em navy.
    Button: {
      controlHeight: 44,
      fontWeight: 600,
      colorPrimary: '#00E590',
      colorPrimaryHover: '#00CC80',
      colorPrimaryActive: '#00B873',
      primaryColor: '#00073C',
      defaultColor: '#00073C',
      defaultBorderColor: '#00073C',
    },
    Input: { controlHeight: 46 },
    Select: { controlHeight: 46 },
    DatePicker: { controlHeight: 46 },
    InputNumber: { controlHeight: 46 },
    Table: {
      headerBg: '#FFFFFF',
      headerColor: '#5F5E5A',
      rowHoverBg: '#FAFAF7',
      borderColor: '#E8E6DF',
    },
    Card: { colorBorderSecondary: '#E8E6DF' },
    // O Ant usa controlHeight como altura mínima do balão. Com os 44px de alvo
    // de toque do protótipo sobrava espaço abaixo do texto, porque o conteúdo
    // mede 35px e a diferença cai toda embaixo. Balão não é alvo de toque: aqui
    // a altura é a do texto com o respiro de 6px em cima e embaixo.
    Tooltip: { controlHeight: 32 },
    Drawer: { colorBgElevated: '#FFFFFF' },
    Tag: { defaultBg: '#F4F2EC', defaultColor: '#00073C' },
  },
}
